import { render, staticRenderFns } from "./bookSuggest.vue?vue&type=template&id=41ec1941&scoped=true&"
import script from "./bookSuggest.vue?vue&type=script&lang=js&"
export * from "./bookSuggest.vue?vue&type=script&lang=js&"
import style0 from "./bookSuggest.vue?vue&type=style&index=0&id=41ec1941&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ec1941",
  null
  
)

export default component.exports